import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { media } from '../theme/base/mixins';
import {
  StyledLIComponent,
  StyledSpanComponent,
  StyledUListComponent
} from '../types';
import { FontIcon, FontIconKey, FontIconSpan } from './FontIcon';
import { IconKey } from './SvgIcon';
import { Image } from './Image';

interface ContactItemProps {
  show?: boolean;
  icon?: FontIconKey | IconKey;
}

type ContactItemPropsThemed = ThemeProps<Theme> & ContactItemProps;

export const ContactItem: StyledLIComponent<ContactItemProps> = styled.li`
  margin: 7px 0;
  font-size: 2rem;

  > a,
  > span {
    font-size: 2rem;
    padding-left: 30px;
  }

  display: ${(props: ContactItemPropsThemed) =>
    props.show ? 'list-item' : 'none'};
`;

export const ContactTextItem: StyledSpanComponent = styled.span`
  display: inline-block;
  color: inherit;
  padding-left: 30px;
`;

export const ContactAdress = styled.div`
  display: inline-block;
  white-space: normal;
  padding-left: 30px;

  ${ContactTextItem} {
    display: block;
    padding-left: 0;
  }
`;

export const FontIconItem = FontIcon.withComponent(ContactItem);

interface ContactProps {
  large?: boolean;
}

export const Contact: StyledUListComponent<ContactProps> = styled.ul`
  font-size: ${(props: ContactProps) => (props.large ? '3' : '2.4')}rem;
  line-height: 1.25;
  font-weight: 300;

  ${FontIconItem}, ${FontIcon}, ${FontIconSpan} {
    &:before {
      vertical-align: top;
      color: ${(props: ThemeProps<Theme>) => props.theme.colors.primary};
      position: absolute;
    }
  }
`;

export const LocationContactContainer = styled.div`
  padding-top: 80px;
`;

export const ContactImage = styled.div`
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;

  ${media.large`
    height: 180px;

    ${Image} {
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
    }
  `};
`;
